import { render, staticRenderFns } from "./analyzeQuestion.vue?vue&type=template&id=77bacdd8&scoped=true"
import script from "./analyzeQuestion.vue?vue&type=script&lang=js"
export * from "./analyzeQuestion.vue?vue&type=script&lang=js"
import style0 from "./analyzeQuestion.vue?vue&type=style&index=0&id=77bacdd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bacdd8",
  null
  
)

export default component.exports